import React, { useEffect, useState } from "react";
import "./Choose_Your_Quiz.css";
import Fill_Detail_Modal from "../../fill-details-modal/Fill_Detail_Modal";

import { useDispatch, useSelector } from "react-redux";
import { AllQuiz } from "../../../features/admin/common/Slice";
import { IDS } from "../../../utils/IDS";

const Choose_Your_Quiz = () => {
  // const quizData = [
  //   {
  //     id: 1,
  //     title: "HTML Fundamentals Quiz",
  //     description:
  //       "Test your understanding of basic HTML concepts including tags, structure, & elements used to build web pages.",
  //     image: "/assets/images/claim_certificate/html-img.png",
  //     points: [
  //       "10+ Concept-Based Questions",
  //       "15-Minute Quick Test",
  //       "Beginner-Level Assessment",
  //       "Instant Score & Feedback",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "HTML Fundamentals Quiz",
  //     description:
  //       "Test your understanding of basic HTML concepts including tags, structure, & elements used to build web pages.",
  //     image: "/assets/images/claim_certificate/html-img.png",
  //     points: [
  //       "10+ Concept-Based Questions",
  //       "15-Minute Quick Test",
  //       "Beginner-Level Assessment",
  //       "Instant Score & Feedback",
  //     ],
  //   },
  //   {
  //     id: 3,
  //     title: "HTML Fundamentals Quiz",
  //     description:
  //       "Test your understanding of basic HTML concepts including tags, structure, & elements used to build web pages.",
  //     image: "/assets/images/claim_certificate/html-img.png",
  //     points: [
  //       "10+ Concept-Based Questions",
  //       "15-Minute Quick Test",
  //       "Beginner-Level Assessment",
  //       "Instant Score & Feedback",
  //     ],
  //   },
  // ];

  const dispatch = useDispatch();
  const quizData = useSelector((state) => state.common.all_quiz);
  const [show, setShow] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState(null);

  useEffect(() => {
    dispatch(AllQuiz());
  }, [dispatch]);

  const handleStartQuiz = (quiz) => {
    setSelectedQuiz(quiz);
    setShow(true);
  };

  return (
    <section className="Choose_Your_Quiz">
      <div className="container">
        <div className="Choose_Your_Quiz_header">
          <h5>
            {" "}
            Choose Your <span> Quiz</span>{" "}
          </h5>

          <span>
            <img
              src="/assets/images/home/FAQ/title-img.png"
              alt="title-img"
              className="title_img"
            />
          </span>
        </div>

        <div className="quiz_section">
          {quizData.map((quiz) => (
            <div className="quiz_card" key={quiz.id}>
              <div className="row ">
                <div className="col-lg-3 col-md-3">
                  <div className="html_img_holder">
                    <img
                      src={
                        quiz.image
                          ? `${IDS.IMG_URL}${quiz.image}`
                          : "/assets/images/placeholder.png"
                      }
                      alt={quiz.title}
                      className="quiz_image"
                    />
                  </div>
                </div>

                <div className="col-lg-9 col-md-9">
                  <div className="html_content_div">
                    <div className="quiz_content">
                      <h4 className="quiz_title">{quiz.title}</h4>

                      <p className="quiz_desc">{quiz.subtitle}</p>

                      {quiz.description &&
                        typeof quiz.description === "string" &&
                        // Check if string contains HTML tags
                        (/<\/?[a-z][\s\S]*>/i.test(quiz.description) ? (
                          <div
                            className="quiz_desc"
                            dangerouslySetInnerHTML={{
                              __html: quiz.description,
                            }}
                          />
                        ) : (
                          <p className="quiz_desc">{quiz.description}</p>
                        ))}


                      {Array.isArray(quiz.description) &&
                        quiz.description.length > 0 && (
                          <>
                            <h6 className="key_points">Key Points:</h6>
                            <ul className="quiz_points">
                              {quiz.description.map((point, idx) => (
                                <li key={idx}>{point}</li>
                              ))}
                            </ul>
                          </>
                        )}
                    </div>

                    <div className="start_btn_div">
                      {/* <button
                        className="start_btn"
                        onClick={() => setShow(true)}
                      >
                        Start Quiz
                      </button> */}

                      <button
                        className="start_btn"
                        onClick={() => handleStartQuiz(quiz)}
                      >
                        Start Quiz
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Fill_Detail_Modal
        show={show}
        handleClose={() => setShow(false)}
        quiz={selectedQuiz}
      />
    </section>
  );
};

export default Choose_Your_Quiz;
